// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Auto-Fill Field Wrapper Styles
 * Provides consistent spacing and layout for field + suggestions
 */

.auto-fill-field-wrapper {
    position: relative;
    width: 100%;
}

.auto-fill-field-wrapper .form-group,
.auto-fill-field-wrapper .modern-form-group {
    margin-bottom: 0;
    /* Remove default margin since wrapper handles spacing */
}

/* Ensure proper spacing between field and suggestions */
.auto-fill-field-wrapper>*:not(.auto-fill-field-suggestion) {
    margin-bottom: var(--space-2);
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .auto-fill-field-wrapper {
        margin-bottom: var(--space-3);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/AutoFillFieldWrapper.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA,wDAAwD;AACxD;IACI,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;IACI;QACI,6BAA6B;IACjC;AACJ","sourcesContent":["/**\n * Auto-Fill Field Wrapper Styles\n * Provides consistent spacing and layout for field + suggestions\n */\n\n.auto-fill-field-wrapper {\n    position: relative;\n    width: 100%;\n}\n\n.auto-fill-field-wrapper .form-group,\n.auto-fill-field-wrapper .modern-form-group {\n    margin-bottom: 0;\n    /* Remove default margin since wrapper handles spacing */\n}\n\n/* Ensure proper spacing between field and suggestions */\n.auto-fill-field-wrapper>*:not(.auto-fill-field-suggestion) {\n    margin-bottom: var(--space-2);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .auto-fill-field-wrapper {\n        margin-bottom: var(--space-3);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
